// src/l1packs/english.js
// Source: "Norwegian speech sounds compared to English" (Olaf Husby, NTNU NoW) :contentReference[oaicite:2]{index=2}

export const ENGLISH_PACK = {
  meta: {
    code: "en",
    name: "English",
    source: "NTNU NoW – Norwegian speech sounds compared to English (Olaf Husby)",
  },

  // IPA -> { overlap, no (Norwegian examples), l1 (English examples), comment }
  byIpa: {
    // ---- Consonants ----
    p: { overlap: "+", no: ["på"], l1: ["paw"], comment: "" },
    b: { overlap: "+", no: ["bi"], l1: ["be"], comment: "" },
    t: { overlap: "~", no: ["tå"], l1: ["taw"], comment: "NO: dental; ENG: alveolar" },
    d: { overlap: "~", no: ["deg"], l1: ["day"], comment: "NO: dental; ENG: alveolar" },
    "ʈ": { overlap: "-", no: ["smart"], l1: [], comment: "" },
    "ɖ": { overlap: "-", no: ["ferdig"], l1: [], comment: "" },
    k: { overlap: "+", no: ["kåt"], l1: ["caught"], comment: "" },
    "ɡ": { overlap: "+", no: ["glass"], l1: ["glass"], comment: "" },
    m: { overlap: "+", no: ["min"], l1: ["mean"], comment: "" },
    n: { overlap: "+", no: ["nei"], l1: ["nay"], comment: "" },
    "ɳ": { overlap: "-", no: ["barna"], l1: [], comment: "" },
    "ŋ": { overlap: "+", no: ["ring"], l1: ["ring"], comment: "" },
    f: { overlap: "+", no: ["fiks"], l1: ["fix"], comment: "" },

    // Normalized from /v/ in the PDF to canonical /ʋ/
    "ʋ": { overlap: "~", no: ["vest"], l1: ["vest"], comment: "ENG /v/ is more fricative" },

    s: { overlap: "+", no: ["si"], l1: ["see"], comment: "" },
    "ʃ": { overlap: "+", no: ["ski"], l1: ["she"], comment: "" },
    "ç": { overlap: "-", no: ["kjapp"], l1: [], comment: "" },
    j: { overlap: "+", no: ["jet"], l1: ["yet"], comment: "" },
    h: { overlap: "+", no: ["hi"], l1: ["he"], comment: "" },

    // /r/ appears twice in the PDF with different contexts; keep one tile and show both analogies.
    r: {
      overlap: "~",
      no: ["rein", "verre"],
      l1: ["rain", "very"],
      comment: "ENG: /r/ is more fricative initially; between vowels can be closer to NO",
    },

    l: { overlap: "~", no: ["lin"], l1: ["lean"], comment: "/l/ can be velarised in EN" },
    "ɭ": { overlap: "-", no: ["jarl"], l1: [], comment: "" },

    // ---- Vowels ----
    i: { overlap: "~", no: ["sinn"], l1: ["sin"], comment: "" },
    "iː": { overlap: "+", no: ["mi"], l1: ["me"], comment: "" },
    y: { overlap: "-", no: ["synd"], l1: [], comment: "" },
    "yː": { overlap: "-", no: ["lys"], l1: [], comment: "" },
    e: { overlap: "+", no: ["send"], l1: ["send"], comment: "" },
    "eː": { overlap: "~", no: ["ler"], l1: ["lair"], comment: "" },
    "ø": { overlap: "-", no: ["søtt"], l1: [], comment: "" },
    "øː": { overlap: "-", no: ["møt"], l1: [], comment: "" },
    "æ": { overlap: "~", no: ["vært"], l1: ["daddy"], comment: "" },
    "æː": { overlap: "~", no: ["mædi"], l1: ["mad"], comment: "" },
    "ɑ": { overlap: "-", no: ["ta"], l1: [], comment: "" },
    "ɑː": { overlap: "~", no: ["spa"], l1: ["spa"], comment: "" },
    "ʉ": { overlap: "~", no: ["full"], l1: ["full"], comment: "" },
    "ʉː": { overlap: "~", no: ["tur"], l1: ["tour"], comment: "" },
    u: { overlap: "-", no: ["bodd"], l1: [], comment: "" },
    "uː": { overlap: "-", no: ["bod"], l1: [], comment: "" },
    o: { overlap: "~", no: ["dott"], l1: ["dot"], comment: "" },
    "oː": { overlap: "~", no: ["lån"], l1: ["lawn"], comment: "" },

    // ---- Diphthongs ----
    "ɑi": { overlap: "+", no: ["hai"], l1: ["hi"], comment: "" },

    // Normalized: PDF shows /ei/; we use canonical /æi/ for “ei”.
    "æi": { overlap: "-", no: ["hei"], l1: [], comment: "PDF writes /ei/; normalized to canonical /æi/." },

    "øy": { overlap: "-", no: ["høy"], l1: [], comment: "" },
    "æʉ": { overlap: "-", no: ["sau"], l1: [], comment: "" },
    oy: { overlap: "+", no: ["soya"], l1: ["soya"], comment: "" },
    uy: { overlap: "-", no: ["hoie"], l1: [], comment: "Sjelden i norsk" },
    "ʉy": { overlap: "-", no: ["huie"], l1: [], comment: "Sjelden i norsk" },
  },
};
